<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl v-if="!$route.path.includes('/contract/orderlist')" ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`合同运单_自有车辆_待审核`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      :tableHeight="tableHeight" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #orderNum="params">
        <div class="orderNum" :class="params.params.is_reject == 1 ? 'tui' : ''">
          {{ params.params.order_num }}
        </div>
      </template>
      <template #status="params">
        <span class="status status0" v-if="params.params.isfleet == 1">队长未审</span>
        <span class="status status1" v-if="params.params.isfleet == 2">队长已审</span>
      </template>
      <template #btns="params">
        <Btn v-if="showEditBtn(params.params)" :config="btns[0]" :data="params.params" />
        <Btn v-if="!showEditBtn(params.params)" :config="viewBtn" :data="params.params" />
        <Btn :config="btns[1]" :data="params.params" />
        <Btn :config="btns[2]" :data="params.params" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import ordermixin from "../../../nonContractOrder/own/mixin";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, ordermixin, mixin],
  data() {
    return {
      formInline: {
        order_type: 2,
        ischeck: 1,
        isstatus: 5,
      },
      formCtrl: [],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "order_num", label: "运单编号", minwidth: 150, slot: 'orderNum' },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 110  },
        { keyName: "pricing", label: "计价方式", minwidth: 110  },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "isfleet", label: "审核状态", slot: 'status', minwidth: 120 },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns', minwidth: 130 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            let path = `/order/contractview5`
            if (this.$route.path.includes('/contract/orderlist')) {
              path = '/contract/orderview5'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'edit',
              }
            });
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id, isfleet }) => {
            // console.log('id', id)
            const { user_group_id } = this.user
            let mode = 'edit'
            if (
              user_group_id == 5 && isfleet == 2 ||
              ([2, 3, 4].includes(user_group_id) && isfleet == 1)
            ) {
              mode = 'view'
            }
            // console.log(id)
            const query = {
              id,
              mode,
            }
            let path = '/order/contractfee'
            if (this.$route.path.includes('/contract/orderlist')) {
              path = '/contract/orderFeeDetail'
            }
            this.$router.push({
              path,
              query,
            });
          },
        },
      ],
      viewBtn: {
        ...this.viewBtn,
        cb: ({ id }) => {
          // console.log(id)
            let path = `/order/contractview4`
            if (this.$route.path.includes('/contract/orderlist')) {
              path = '/contract/orderview4'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'view',
              }
            });
        },
      },
    };
  },
  methods: {
    showEditBtn(a) {
      let boo = false
      const { user_group_id } = this.user
      const { isstatus, isover, is_reject, isfleet } = a
      if (
        // 司机
        user_group_id == 9 && (isstatus == 3 && isover == 1 || (is_reject == 1 && isover == 1) || isstatus == 2) ||
        // 队长
        (user_group_id == 5 && (isstatus == 3 && isover == 2 && isfleet == 1 || (isstatus == 3 && isover == 1) || [1, 2].includes(isstatus))) ||
        // 财务
        ([2, 3, 4].includes(user_group_id) && isstatus == 3 && isover == 2 && isfleet == 2) ||
        // 超管
        user_group_id == 1
      ) {
        boo = true
      }
      return boo
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: this.delete,
      })
    }
    // if ([5].includes(user_group_id)) {
    //   this.btns[1] = {
    //     ...this.viewBtn,
    //     cb: ({ id }) => {
    //       this.$router.push(
    //         `/order/contractview3?id=${id}&mode=view`
    //       );
    //     },
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
@tuiSize: 15px;

.main {
  .table-wrap {
    /deep/ .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tui {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: @tuiSize;
          height: @tuiSize;
          background: url(../../../../../assets/img/icon_reject.png) no-repeat center center;
          background-size: @tuiSize;
          margin-left: 5px;
        }
      }

      .status {
        &.status1 {
          color: #98e098;
        }

        &.status0 {
          color: #fd5b5b;
        }
      }
    }
  }
}
</style>
